/*
 * Switches between the collections in a Featured Collection section.
 *
 * Panels are toggled with the `hidden` attribute rather than a class, so a
 * revealed panel goes from zero width to a real width. Dawn's SliderComponent
 * watches its own slider with a ResizeObserver, so it recalculates its pages on
 * its own when that happens — no re-init needed here.
 */
class CollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
      tab.addEventListener('keydown', this.onKeyDown.bind(this));
    });
  }

  onTabClick(event) {
    event.preventDefault();
    this.select(event.currentTarget);
  }

  onKeyDown(event) {
    const index = this.tabs.indexOf(event.currentTarget);
    if (index === -1) return;

    let nextIndex = null;
    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (index + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    this.select(nextTab);
    nextTab.focus();
  }

  select(selectedTab) {
    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');

      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.toggleAttribute('hidden', !isSelected);
    });
  }
}

customElements.define('collection-tabs', CollectionTabs);
